function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapFilterMaterials = function SvgLivemapFilterMaterials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37.998,
    viewBox: "0 0 38 37.998"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raw Materials"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.3 148.3h-9.961c-.639-2.521-9.911-2.43-9.912.28a1.14 1.14 0 0 0 .016.14.5.5 0 0 0-.016.08v15.113c0 1.4 2.5 2.138 4.974 2.138 1.867 0 3.748-.42 4.56-1.229H672.3a.5.5 0 0 0 .49-.5V148.8a.5.5 0 0 0-.49-.5zm-14.9-.858c2.636 0 3.995.8 3.995 1.137s-1.359 1.137-3.995 1.137-3.994-.8-3.994-1.137 1.357-1.137 3.992-1.137zm0 17.609c-2.635 0-3.994-.8-3.994-1.137V149.9a10.2 10.2 0 0 0 7.989 0v14.011c0 .34-1.361 1.137-4 1.137zm14.409-1.229h-9.436V149.3h9.434v14.521z",
    style: {
      fill: "#4da5b5",
      stroke: "#4da5b5",
      strokeWidth: ".5px",
      fillRule: "evenodd"
    },
    transform: "translate(-644.103 -138.045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z",
    "data-name": "Rectangle 4469",
    style: {
      fill: "none"
    },
    transform: "translate(4.507 4.611)"
  }))));
};
export default SvgLivemapFilterMaterials;